const initialState = {
  resultsCouponsList: [],
  resultsCoupon: {},
  resultsCouponPut: {},
  resultsCouponCreate: {},
  resultsCouponCodeDetail: {},
  resultsCouponCodeDetailPut: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_COUPON_RESPONSE_GET":
      newState.resultsCouponsList = action.value;
      break;
    case "COUPON_RESPONSE_GET":
      newState.resultsCoupon = action.value;
      break;
    case "COUPON_RESPONSE_UPDATE":
      newState.resultsCouponPut = action.value;
      break;
    case "COUPON_RESPONSE_CREATE":
      newState.resultsCouponCreate = action.value;
      break;
    case "COUPON_RESPONSE_RESET":
      newState.resultsCoupon = {};
      newState.resultsCouponCreate = {};
      newState.resultsCouponPut = {};
      break;
    case "COUPON_CODE_DETAIL_RESPONSE_GET":
      newState.resultsCouponCodeDetail = action.value;
      break;
    case "COUPON_CODE_DETAIL_RESPONSE_UPDATE":
      newState.resultsCouponCodeDetailPut = action.value;
      break;
    case "COUPON_CODE_DETAIL_RESPONSE_RESET":
      newState.resultsCouponCodeDetail = {};
      newState.resultsCouponCodeDetailPut = {};
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;



